<script>
  import {
   Paper
  } from "@svelteuidev/core";
  import { onMount } from "svelte";
  import Conexoes from "../Classes/Conexoes";
  import Constantes from "../Classes/Constantes.js";
  import { DadosLogin } from "../Classes/Stores";
  import LoadingTela from "../componentes_basicos/LoadingTela.svelte";
  import CaixaDeDialogo from "../componentes_basicos/CaixaDeDialogo.svelte";
  export let params;
  let id_campeonato = params;
  let api = Constantes.api_consultar_padrao;
  let message;
  let id_usuario  = $DadosLogin.id_usuario;
  //let id_usuario = 246;
  let parametros = { 
    id_usuario: id_usuario,
    id_campeonato: id_campeonato,
    query_code:
      Constantes.query_code_consultar_eventos_incritos_pagos_para_checkin,
  };

  let conexoes = new Conexoes();
  let minhasInscricoes = [];
  let isLoading = false;
  let inscrito1 = "";
  let inscrito2 = "";
  let nome_equipe = "";
  let nome_categoria = "";
  let checkins = [];
  let cod;
  let confirmaCheckinModal = false;
 
  function confirmaCheckin(e) {
    cod = e;
    confirmaCheckinModal = true;
    confirma();
  }

  async function confirma() {
    // colcoar aqui a código para o checkin no banco
    isLoading = true;
    let result = await conexoes.conecta(Constantes.api_inserir_sem_query_code, {
      cod_inscricao_encurtado: cod,
      tabela: "check_in_campeonato"
    },null, "Deseja realizer o Check-in? Com a realização do Check-in online você(s) confirma(m) sua(s)   participação(ões) no Evento");

    if (result && result.sucesso) {
      message = Constantes.msg_inserido_sucesso;
      window.location.reload();
    } else if(result) {
      message = Constantes.msg_erro_conexao_bd;
    }
    isLoading = false;
    confirmaCheckinModal = false;
  }

  function cancela() {
    confirmaCheckinModal = false;
  }

  export async function conectar() {
    isLoading = true;
    minhasInscricoes = await conexoes.conecta(api, parametros);

    isLoading = false;
    if (minhasInscricoes) {
       
      minhasInscricoes.forEach((element) => {
        let parametro = {};
        parametro["inscrito1"] = element.inscritos;
        try {
          parametro["inscrito1"] = parametro["inscrito1"].replace(";", "<br>");
        } catch (error) {}
        parametro["nome_equipe"] = element.nome_equipe;
        parametro["nome_categoria"] = element.nome_categoria;
        parametro["cod_inscricao_encurtado"] = element.cod_inscricao_encurtado;

        checkins = [...checkins, parametro];
      });
    }
  }

  // Conectar ao carregar o componente
  onMount(async () => {
    await id_usuario;
    conectar();
  });
</script>

<CaixaDeDialogo {message} on:close={() => (message = "")} />
<LoadingTela {isLoading} />
<br>
<br>
<div class="margem">
  <div class="fonte">
    <strong>Check in</strong>
  </div>
  {#if checkins.length>0}
  {#each checkins as checkin}
  <Paper>
    <div>Nome(s): <b><br /> {@html checkin.inscrito1}</b><br /><br /></div>
    <div>Categoria: <b><br /> {checkin.nome_categoria} </b><br /><br /></div>
    <div>Equipe: <b><br /> {checkin.nome_equipe} </b><br /><br /></div>

    <button
      class="buttonAzul"
      on:click={() => confirmaCheckin(checkin.cod_inscricao_encurtado)}
      >Realizar Check-In</button
    >
    </Paper><hr>
  {/each}
  {:else}
<h1>Sem chekins a realizar</h1>
  {/if}

  <!--
  {#if confirmaCheckinModal}
    <div class="modal show">
      <div class="modal-content">
        <p><strong>CHECK-IN FESTIVAL ARMY CHAMPIOSHIP</strong></p>
        <p>
          Com a realização do Check-in online você(s) confirma(m) sua(s)
          participação(ões) no Evento
        </p>
        <button class="buttonVerde" on:click={confirma}>Confirmar</button>
        <br />
        <button class="buttonVermelho" on:click={cancela}>Cancelar</button>
      </div>
    </div>
  {/if}
  -->
</div>
<br>
<br>
<style>
  button {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .buttonAzul {
    background-color: #1976d2;
  }

  .buttonVermelho {
    background-color: #ee7171;
  }

  .buttonVerde {
    background-color: #67ca7b;
  }

  .modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
  }

  .modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 40%;
  }

  .margem {
    margin-top: 70px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .fonte {
    font-size: 30px;
    font-weight: bold;
    color: #000080;
    text-align: center;
  }
</style>
